import { PagePropertyType } from '@affine/core/modules/properties/services/schema';
import type { I18nString } from '@affine/i18n';

import { CheckboxValue } from './checkbox';
import { CreatedUserValue, UpdatedUserValue } from './created-updated-by';
import { CreatedDateValue, DateValue, UpdatedDateValue } from './date';
import { DocPrimaryModeValue } from './doc-primary-mode';
import { NumberValue } from './number';
import { TagsValue } from './tags';
import { TextValue } from './text';
import type { PropertyRowValueProps } from './types';

export type DocPropertyType = Record<
  PagePropertyType,
  {
    icon?: string;
    value?: React.FC<PropertyRowValueProps>;
    /**
     * set a unique id for property type, make the property type can only be created once.
     */
    uniqueId?: string;
    name: I18nString;
    readonly?: boolean;
    renameable?: boolean;
    // description?: I18nString;
  }
>;

export const DocPropertyTypes: DocPropertyType = {
  [PagePropertyType.Tags]: {
    value: TagsValue,
    name: 'com.affine.doc-properties.property.tags',
    uniqueId: 'tags',
    renameable: false,
  },
  [PagePropertyType.Date]: {
    value: DateValue,
    name: 'com.affine.doc-properties.property.date',
  },
  [PagePropertyType.Checkbox]: {
    value: CheckboxValue,
    name: 'com.affine.doc-properties.property.checkbox',
  },
  [PagePropertyType.Text]: {
    value: TextValue,
    name: 'com.affine.doc-properties.property.text',
  },
  [PagePropertyType.Number]: {
    value: NumberValue,
    name: 'com.affine.doc-properties.property.number',
  },
  [PagePropertyType.CreatedAt]: {
    value: CreatedDateValue,
    name: 'com.affine.doc-properties.property.createdAt',
    readonly: true,
    renameable: false,
  },
  [PagePropertyType.UpdatedAt]: {
    value: UpdatedDateValue,
    name: 'com.affine.doc-properties.property.updatedAt',
    readonly: true,
    renameable: false,
  },
  [PagePropertyType.CreatedBy]: {
    value: CreatedUserValue,
    name: 'com.affine.doc-properties.property.createdBy',
    readonly: true,
  },
  [PagePropertyType.UpdatedBy]: {
    value: UpdatedUserValue,
    name: 'com.affine.doc-properties.property.updatedBy',
    readonly: true,
  },
  [PagePropertyType.DocPrimaryMode]: {
    value: DocPrimaryModeValue,
    name: 'com.affine.doc-properties.property.docPrimaryMode',
  },
};

export const isSupportedDocPropertyType = (type?: string): boolean => {
  return type ? type in DocPropertyTypes : false;
};
